<template lang="pug">
    .list
        .list__content(v-if="$can('addItem', type)")
            .box
                .form-container__header
                    .form-container__title(v-text='homeworkEditorHeader')
                    .form-container__subtitle(v-if='!isPreload && !editable')
                        | {{ $i18n.t('homework.homework_create_notEditable') }}
                form(@submit.prevent='submitForm')
                    .form-container__fields
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('homework.homework_create_school') }}
                                .form-container__select
                                    div
                                        cs-multiselect(
                                            :multiple='false',
                                            :options='schools',
                                            :show-labels='false',
                                            :allow-empty='true',
                                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                                            label='name',
                                            track-by='id',
                                            :searchable='true',
                                            :loading='loadingSchools',
                                            @open='getSchools',
                                            v-model='form.school',
                                            v-validate="'required'",
                                            data-vv-value-path='innerValue',
                                            data-vv-name='school',
                                            :data-vv-as="$i18n.t('homework.homework_create_schoolVvSs')",
                                            :disabled='!editable || loadingGrades'
                                        )
                                            span(slot='noResult')
                                                | {{ $i18n.t('homework.homework_create_schoolNotFound') }}
                                    span.help.is-danger(v-show="errors.has('school')") {{ errors.first('school') }}
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('homework.homework_create_grade') }}
                                .form-container__select
                                    div
                                        cs-multiselect.multiple-multiselect(
                                            :options='availableGrades',
                                            :show-labels='false',
                                            :allow-empty='true',
                                            :hide-selected='true',
                                            :placeholder='gradesPlaceholder',
                                            label='name',
                                            track-by='id',
                                            :close-on-select='false',
                                            :clear-on-select='false',
                                            :multiple='true',
                                            :max='null',
                                            :searchable='true',
                                            :loading='loadingGrades',
                                            v-model='form.grades',
                                            v-validate="'required'",
                                            data-vv-value-path='innerValue',
                                            data-vv-name='grades',
                                            :data-vv-as="$i18n.t('homework.homework_create_gradeVvSs')",
                                            @remove='removeGrade',
                                            @select='selectGrade',
                                            :disabled='!grades.length || loadingStudents || !editable'
                                        )
                                        span.help.is-danger(v-if="errors.has('grade')") {{ errors.first('grade') }}
                        .row
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('homework.homework_create_students') }}
                                .form-container__select
                                    div
                                        cs-multiselect.multiple-multiselect(
                                            :options='students',
                                            :show-labels='false',
                                            :hide-selected='true',
                                            :max='null',
                                            label='fullName',
                                            track-by='id',
                                            :close-on-select='false',
                                            :clear-on-select='false',
                                            :placeholder='studentsPlaceholder',
                                            :multiple='true',
                                            v-model='form.students',
                                            :disabled='students.length === 0 || !editable',
                                            v-validate="'required'",
                                            data-vv-value-path='innerValue',
                                            data-vv-name='students',
                                            :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                                        )
                                        span(v-show="errors.has('students')") {{ errors.first('students') }}
                                        .all-students-text(v-show="editable")
                                            a(href='javascript://', @click='addAllStudentsToGrade')
                                                | {{ $i18n.t('homework.homework_create_addAllStudents') }}
                        .row(v-for='index in amountOfDates')
                            .form-container__column
                                label.form-container__label.form-container__label_nowrap(
                                    v-text="index === 1 ? $i18n.t('homework.homework_create_executeTime') : ''",
                                    :class="{'label_hidden': index !== 1}"
                                )
                                .form-container__select(v-if="index === 1")
                                    cs-datepicker(
                                        :language='user.locale',
                                        v-validate='{ required: true }',
                                        @input='dateToMoment($event, index - 1)',
                                        :format='customFormatter',
                                        :value='dates[index - 1]',
                                        :selected-date='dates[index - 1]',
                                        :highlighted="{dates}",
                                        :data-vv-as="$i18n.t('homework.homework_create_executeTimeVvSs')",
                                        :placeholder="$i18n.t('homework.homework_create_executeTimePlaceholder')",
                                        :class="{'is-danger': errors.has('date')}",
                                        autocomplete='off',
                                        :disabled='!editable',
                                        name='date'
                                        :is-multiply="!homeworkLimitTariff && !id"
                                    )
                                    span.info-text(v-show='index === amountOfDates && dates.length >= 2')
                                        | {{ $i18n.t('homework.homework_create_manyDates') }}
                                    span(v-if='!editable')
                                        | {{ $i18n.t('homework.homework_create_notChangeable') }}
                                    span(v-show="errors.has('date')") {{ errors.first('date') }}
                                .form-container__select(v-else)
                                    cs-input(
                                        :value='customFormatter(dates[index - 1])',
                                        v-validate='{ required: true }',
                                        disabled
                                    )
                                .remove-date-button(v-if="dates.length >= 2")
                                    a(
                                        href='javascript://',
                                        @click='dates.splice(index - 1, 1)',
                                        v-if='dates.length >= 2 && dates[index - 1]'
                                    )
                                        svg-icon.delete-icon(:style="{top: index > 1 ? '20%' : '50%'}", size="x-large", name="circle-close")
                        .row(v-if="!homeworkLimitTariff")
                            .form-container__column
                                label.form-container__label
                                    | {{ $i18n.t('homework.homework_create_template') }}
                                .form-container__select
                                    cs-multiselect(
                                        :options='homeworkTemplates',
                                        :placeholder='templatesPlaceholder',
                                        label='name',
                                        track-by='id',
                                        :multiple='false',
                                        :searchable='true',
                                        :loading='loadingHomeworkTemplates',
                                        :value='form.homeworkTemplate',
                                        @select='selectTemplate',
                                        @remove='removeTemplate',
                                        :disabled='!isMainParametersSet || !homeworkTemplates.length',
                                        @open='getTemplates'
                                    )
                    divider.form-container__divider
                    template(v-if='isMainParametersSet')
                        .form-container__fields.games-fields
                            template(v-for='index in amountOfGames')
                                .row(v-if='(editable || form.games[index - 1]) && !(homeworkLimitTariff && index !== 1)')
                                    .form-container__column
                                        label.form-container__label(
                                            v-text="index === 1 ? $i18n.t('homework.homework_create_chooseGames') : ''",
                                            :class="{'label_hidden': index !== 1}"
                                        )
                                        .form-container__select
                                            div
                                                cs-multiselect(
                                                    :multiple='false',
                                                    :options='games',
                                                    :show-labels='false',
                                                    :allow-empty='false',
                                                    :placeholder="games.length === 0 ? '' : $i18n.t('homework.homework_create_chooseGames')",
                                                    :disabled='games.length === 0 || !editable',
                                                    label='name',
                                                    :value='form.games[index - 1]',
                                                    @select='gameHandler($event, index - 1)'
                                                )
                                            span.help(v-if='games.length === 0')
                                                | {{ $i18n.t('homework.homework_create_noGameAccess') }}
                        .form-container__fields
                            games-list(
                                :games='form.games',
                                @editGame='editGame',
                                :homeworkid='id',
                                :students='form.students',
                                @up="moveGame($event, 'up')",
                                @down="moveGame($event, 'down')",
                                @remove='removeGame',
                                :editable='editable',
                            )
                    template(v-else)
                        .base-settings-text
                            | {{ $i18n.t('homework.homework_create_baseSettings') }}
                    .form-container-footer
                        cs-button.form-container-footer__button(
                            v-if='id',
                            color="blue"
                            @click="$router.push({name: 'homework:create', params: {copy: form}})"
                        )
                            | {{ $i18n.t('homework.homework_create_copy') }}
                        span.form-container-footer__right
                            cs-button.form-container-footer__button(
                                @click="$router.push({name: 'homework:list'})"
                                color="blue"
                                pattern="primary-outline"
                            )
                                | {{ $i18n.t('common.common_button_cancel') }}
                            cs-button.form-container-footer__button.form-container-footer__button-submit(
                                :loading='isLoading',
                                :disabled='!isMainParametersSet || errors.any() || form.games.length === 0 || isLoading'
                                color="blue"
                                @click="setDaysAmountToOne"
                            )
                                span(v-if='id')
                                    | {{ $i18n.t('homework.homework_create_save') }}
                                span(v-else)
                                    | {{ $i18n.t('homework.homework_create_publish') }}
        div.list__content(v-else)
            | {{ $i18n.t('errors.page_not_access') }}
</template>

<script>
    /*eslint-disable*/
    import SchoolApi from '../../api/school';
    import GradeApi from '../../api/grade';
    import HomeWorkApi from '../../api/homework/homework';
    import UserApi from '../../api/user/user';
    import { mapState } from 'vuex';
    import TrainerUtilities from '../../utils/trainer/trainer';
    import ComparingTrainersParameters from '../../utils/trainer/comparingTrainersParameters';
    import _, { kebabCase } from 'lodash';
    import moment from 'moment';
    import AddSubPreview from '../games/games-previews/AddSubPreview.vue';
    import FlashCardsPreview from '../games/games-previews/FlashCardsPreview.vue';
    import MultDivPreview from '../games/games-previews/MultDivPreview.vue';
    import EquationPreview from '../games/games-previews/EquationPreview.vue';
    import FactorizationPreview from '../games/games-previews/FactorizationPreview.vue';
    import DivideItRightPreview from '../games/games-previews/DivideItRightPreview.vue';
    import ChooseItRightPreview from '../games/games-previews/ChooseItRightPreview.vue';
    import DivideUnstressedVowelsPreview from '../games/games-previews/DivideUnstressedVowelsPreview.vue';
    import WordStructurePreview from '../games/games-previews/WordStructurePreview.vue';
    import ShutterRussianLanguagePreview from '../games/games-previews/ShutterRussianLanguagePreview.vue';
    import SentenceParsingPreview from "../games/games-previews/SentenceParsingPreview.vue";
    import VocabularyWordsRusPreview from '../games/games-previews/VocabularyWordsRusPreview.vue';
    import LettersSoundsSyllablesPreview from '../games/games-previews/LettersSoundsSyllablesPreview.vue';
    import SynonymsRussianLanguagePreview from '../games/games-previews/SynonymsRussianLanguagePreview.vue';
    import TransferSyllablesPreview from '../games/games-previews/TransferSyllablesPreview.vue';
    import TransferSyllablesSchoolPreparingPreview from '../games/games-previews/TransferSyllablesSchoolPreparingPreview.vue';
    import HardSoftConsonantsPreview from '../games/games-previews/HardSoftConsonantsPreview.vue';
    import HardSoftConsonantsSchoolPreparingPreview from '../games/games-previews/HardSoftConsonantsSchoolPreparingPreview.vue';
    import VocabularyMemoRusPreview from '../games/games-previews/VocabularyMemoRusPreview.vue';
    import WordDrumPreview from '../games/games-previews/WordDrumPreview.vue';
    import TranscriptionInWordPreview from '../games/games-previews/TranscriptionInWordPreview.vue';
    import VoicedAndDeafConsonantsPreview from '../games/games-previews/VoicedAndDeafConsonantsPreview.vue';
    import PartsOfSpeechPreview from '../games/games-previews/PartsOfSpeechPreview.vue';
    import ParsingSentencePartsSpeechPreview from '../games/games-previews/ParsingSentencePartsSpeechPreview.vue';
    import SortOneManyPreview from '../games/games-previews/SortOneManyPreview.vue';
    import GenericWordsPreview from '../games/games-previews/GenericWordsPreview.vue';
    import VerbTensesPreview from '../games/games-previews/VerbTensesPreview.vue';
    import PunctuationMarksPreview from '../games/games-previews/PunctuationMarksPreview.vue';
    import AnzanPreview from '../games/games-previews/AnzanPreview.vue';
    import AlphabetPreview from "../games/games-previews/AlphabetPreview.vue";
    import ConnectThePuzzlesPreview from '../games/games-previews/ConnectThePuzzlesPreview.vue';
    import OrthographPreview from '../games/games-previews/OrthographPreview.vue';
    import AntonymsRussianLanguagePreview from '../games/games-previews/AntonymsRussianLanguagePreview.vue';
    import GamesList from '../games/GamesList.vue';

    import { getInitParameters } from '../../utils/trainer/getInitParameters';
    import getBase64FromUrl from '../../utils/getBase64FromUrl';
    import HomeworkTemplateApi from '../../api/templates/template';
    import { getFormattedDate } from '../../utils/getFormattedDate';
    import TrainerGames from '../../config/trainer.json';
    import BonusGamesApi from '../../api/bonusGames/bonusGames';
    import { TARIFF_IDS_WITH_HOMEWORK_LIMIT } from '@/config/tariff_constants';

    const GAMES_WITH_MULTIPLE_DATES = ['Texts', 'TextsOnline', 'Puzzle', 'PunctuationMarks', 'Orthograph'];

    export default {
        data() {
            return {
                form: {
                    school: null,
                    grades: [],
                    students: [],
                    games: [],
                    dates: [],
                    homeworkTemplate: null,
                },
                schools: [],
                grades: [],
                students: [],
                dates: [],
                amountOfGames: 1,
                amountOfDates: 1,
                loadingStudents: false,
                loadingSchools: false,
                loadingGrades: false,
                isLoading: false,
                homeworkTemplates: [],
                loadingHomeworkTemplates: false,
                editable: true,
                isPreload: false,
                isSuccessfullyUpdated: false,
                availableBonusGamesSlugSet: new Set(),
                oldBonusGamesSlugSet: new Set(),
            };
        },
        props: ['id', 'copy', 'type'],
        mounted() {
            if (this.homework) {
                this.editable = this.homework.editable;
                this.updateAvailableBonusGamesSlugSet();
            }
            if (this.id && !this.homework) {
                this.fetchData();
            } else if (this.copy) {
                this.form.templateName = this.copy.templateName;
                this.form.students = this.copy.users;
                this.form.grades = this.copy.grades;
                this.form.games = this.copy.exercises;
                this.form.school = this.copy.school;
                this.dates.push(new Date(this.copy.date));
                const course = _.kebabCase(this.form.grades[0].access);
                this.form.games.forEach(game => {
                    game.courseType = course;
                    game.name = this.getGameName(game);
                    if (game.slug === 'Puzzle') {
                        this.assignImage(game);
                        game.parameters.default.isImageChanged = false;
                    }
                });
                this.getStudents().then(students => {
                    this.students = students;
                });
                this.getTemplates();
            }
        },
        watch: {
            id(val) {
                if (!val) {
                    this.dates = [];
                }
            },
            dates: {
                handler(newDates) {
                    this.form.dates = newDates;
                    if (!this.id) {
                        this.amountOfDates = newDates.length || 1;
                    }
                    this.updateDueDatesInFormGames();
                    this.syncTextsWithDates();
                },
                deep: true,
            },
            'form.games.length': {
                handler(newLength) {
                    if (newLength >= 0) {
                        this.amountOfGames = newLength + 1;
                        this.errors.items &&
                            (this.errors.items = this.errors.items.filter(item => item.field !== 'games'));
                    }
                },
            },
            'form.games': {
                handler(val) {
                    val &&
                        this.form.games.forEach(game => {
                            game.name = this.getGameName(game);
                            if (game.slug === 'Puzzle') {
                                const isGameWithMultipleDays = _.isArray(game.parameters.default);
                                if (isGameWithMultipleDays) {
                                    if (game.parameters.default.some(param => param.imageSrc && !param.image)) {
                                        this.assignImage(game);
                                    }
                                } else {
                                    if (game.parameters.default.imageSrc && !game.parameters.default.image) {
                                        this.assignImage(game);
                                    }
                                }
                                game.parameters.default.isImageChanged = false;
                            }
                        });
                },
                deep: true,
                immediate: true,
            },
            'form.grades': {
                handler(grades) {
                    if (!grades) {
                        return;
                    }
                    let coursesIds = grades.map(grade => grade.courseId);
                    let templateCourses = this.form.homeworkTemplate ? this.form.homeworkTemplate.courses : [];
                    if (this.form.homeworkTemplate && !templateCourses.some(course => coursesIds.includes(course.id))) {
                        this.form.homeworkTemplate = null;
                    }
                    this.getTemplates();
                    this.form.games = this.form.games.filter(game => {
                        if (!coursesIds.length) {
                            return false;
                        }
                        if (game.sourceType === 'homeworkTemplate' && !this.form.homeworkTemplate) {
                            return false;
                        }
                        return !game.courseId || coursesIds.includes(game.courseId);
                    });
                },
            },
            'form.school': {
                handler(val, oldVal) {
                    if (!val) {
                        this.form.students = [];
                        this.form.grades = [];
                        this.grades = [];
                        this.students = [];
                        this.form.games = [];
                    }
                    if (oldVal && val && val.id !== oldVal.id) {
                        this.form.students = [];
                        this.form.grades = [];
                        this.form.games = [];
                        this.grades = [];
                        this.students = [];
                        this.form.games = [];
                    }
                    if (val) {
                        this.getGrades();
                    }
                },
                deep: true,
                immediate: true,
            },
            homework: {
                handler(newHomework) {
                    if (newHomework) {
                        this.form = newHomework;
                        this.dates = [...newHomework.dates.map(date => new Date(date))];
                        this.form.grades.forEach(item => {
                            this.students.push(...item.students);
                        });
                        this.students = this.students.filter(student => student.status === 'active');
                    }
                },
                immediate: true,
            },
            copy: {
                handler(val) {
                    if (val) {
                        this.editable = true;
                    } else if (this.id) {
                        this.editable = false;
                    }
                },
                immediate: true,
            },
            'form.students': {
                handler(studentsArray, oldStudentsArray) {
                    if (this.id && studentsArray.length < oldStudentsArray.length) {
                        let student = _.difference(oldStudentsArray, studentsArray)[0];
                        if (student.pivot.isCompleted) {
                            this.form.students.push(student);
                            this.$toasted.error(this.$i18n.t('homework.homework_create_deleteStudentError'));
                        }
                    }
                },
            },
            courseType: 'updateAvailableBonusGamesSlugSet',
        },
        methods: {
            syncTextsWithDates() {
                this.form.games = this.form.games.map(game => {
                    if (game.slug === 'Texts' || game.slug === 'TextsOnline') {
                        if (_.isArray(game.parameters.default)) {
                            game.parameters.default = game.parameters.default.filter(parameter => {
                                return this.dates
                                    .map(date => {
                                        return getFormattedDate(date, 'YYYY-MM-DD');
                                    })
                                    .includes(parameter.dueDate);
                            });
                        } else if (this.dates.length > 1) {
                            game.parameters.default = [game.parameters.default];
                        }
                    }
                    return game;
                });
                this.$store.dispatch('setHomework', this.form);
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            setDaysAmountToOne() {
                this.form.games = this.form.games.map(game => {
                    if ((game.slug === 'Texts' || game.slug === 'TextsOnline') && _.isArray(game.parameters.default)) {
                        game.parameters.default.map(parameter => {
                            parameter.settings.days = 1;
                            return parameter;
                        });
                    }
                    return game;
                });
            },
            dateToMoment(date, index) {
                const dateIndex = this.dates.findIndex(element => element.toDateString() === date.toDateString());
                if (this.homeworkLimitTariff) {
                    this.dates.splice(0, 1);
                    this.dates[index] = date;
                    return;
                }
                if (dateIndex !== -1) {
                    this.dates.splice(dateIndex, 1);
                } else if (!this.id) {
                    this.dates = [date, ...this.dates];
                } else {
                    this.dates[index] = date;
                }
            },
            removeTemplate() {
                this.form.homeworkTemplate = null;
                this.form.games = this.form.games.filter(game => game.sourceType !== 'homeworkTemplate');
            },
            selectTemplate(template) {
                if (template) {
                    this.form.homeworkTemplate = template;
                    this.form.templateName = template.name;
                    let games = template.games;
                    games.forEach(game => {
                        delete game.id;
                        game.name = this.getGameName(game);
                    });
                    this.form.games = games;
                    this.setDaysAmountToOne();
                    this.updateDueDatesInFormGames();
                }
            },
            updateDueDatesInFormGames() {
                this.form.games = this.form.games.map(game => {
                    if (GAMES_WITH_MULTIPLE_DATES.includes(game.slug)) {
                        if (_.isArray(game.parameters.default)) {
                            game.parameters['default'].map((parameter, counter) => {
                                parameter.dueDate = getFormattedDate(
                                    this.dates[this.dates.length - 1 - counter],
                                    'YYYY-MM-DD'
                                );
                                return parameter;
                            });
                        } else {
                            game.parameters.default.dueDate = getFormattedDate(this.dates[0], 'YYYY-MM-DD');
                            return game;
                        }
                    }
                    return game;
                });
            },
            getTemplates() {
                if (!this.form.grades.length) {
                    return;
                }
                this.loadingHomeworkTemplates = true;
                let params = {
                    coursesIds: this.form.grades.map(grade => grade.courseId),
                    all: true,
                    type: 'homework',
                };
                HomeworkTemplateApi.list(params)
                    .then(response => {
                        let homeworkTemplates = response.data;
                        this.homeworkTemplates = homeworkTemplates ? homeworkTemplates : [];
                        this.loadingHomeworkTemplates = false;
                    })
                    .catch(() => {
                        this.loadingHomeworkTemplates = false;
                        this.$toasted.error(this.$i18n.t('errors.getting_students'));
                    });
            },
            gameHandler(game, index) {
                this.$set(this.form.games, index, _.cloneDeep(game));
                this.form.games[index].parameters.default = _.cloneDeep(getInitParameters(this.form.games[index]));
            },
            async fetchData() {
                this.isPreload = true;
                try {
                    const data = await HomeWorkApi.show(this.id);
                    this.editable = data.homework.editable;
                    this.form.grades = data.homework.grades;
                    this.form.students = data.homework.users;
                    this.form.grades.forEach(item => {
                        this.students.push(...item.students);
                    });
                    this.students = this.students.filter(student => student.status === 'active');
                    this.dates = [new Date(data.homework.date)];
                    this.form.school = data.homework.school;
                    if (!this.homework) {
                        this.form.games = _.cloneDeep(data.homework.exercises);
                    } else {
                        this.form.games = _.cloneDeep(this.homework.games);
                    }
                    this.form.games.forEach(game => {
                        game.name = this.getGameName(game);
                        if (game.slug === 'Puzzle') {
                            this.assignImage(game);
                            game.parameters.default.isImageChanged = false;
                        }
                    });
                    if (this.id && this.editable) {
                        const selectedGamesSlugSet = new Set(this.form.games.map(({ slug }) => slug));
                        this.oldBonusGamesSlugSet = new Set(
                            this.bonusGames.filter(({ slug }) => selectedGamesSlugSet.has(slug)).map(({ slug }) => slug)
                        );
                    }
                    this.amountOfGames = this.form.games.length + 1;
                    this.form.templateName = data.homework.templateName;
                    this.getTemplates();
                    this.isPreload = false;
                } catch (error) {
                    this.isPreload = false;
                }
            },
            async assignImage(game) {
                if (_.isArray(game.parameters.default)) {
                    game.parameters.default.map(async setting => {
                        setting.image = await this.getBase64ImageFromUrl(
                            this.$options.filters.apiFile(setting.imageSrc)
                        );
                    });
                } else {
                    game.parameters.default.image = await this.getBase64ImageFromUrl(
                        this.$options.filters.apiFile(game.parameters.default.imageSrc)
                    );
                }
            },
            removeGrade(grade) {
                if (grade) {
                    this.form.students = _.differenceBy(this.form.students, grade.students, 'id');
                    this.students = _.differenceBy(this.students, grade.students, 'id');
                }
            },
            selectGrade(grade) {
                this.loadingStudents = true;
                this.getStudents(grade).then(students => {
                    this.$nextTick(() => {
                        let grades = this.form.grades;
                        grade = grades[grades.length - 1];
                        if (students && students.length && grade) {
                            this.form.students = this.form.students.concat(students);
                            this.$set(grades[grades.length - 1], 'students', students);
                            this.students = this.students.concat(students);
                        }
                        this.loadingStudents = false;
                    });
                });
            },
            async editGame(index) {
                this.form.dates = this.dates.map(date => moment(date).format());
                const gamesParameters = {};
                const slug = this.form.games[index].slug;
                let game = _.find(this.games, { slug });
                if (game) {
                    gamesParameters[slug] = game.parameters.default;
                    this.form.editable = this.editable;
                    this.$store.dispatch('setHomework', this.form);
                    this.$store.dispatch('setGamesParameters', _.cloneDeep(gamesParameters));
                }
                let params = { gameId: index };
                if (this.id) {
                    params.id = this.id;
                }
                if (this.courseType) {
                    params.courseType = this.courseType;
                }
                if (game && !game.isBonusGame) {
                    this.$router.push({ name: 'game:edit', params: params });
                    return;
                }
                if (this.availableBonusGamesSlugSet.has(slug)) {
                    this.$router.push({ name: 'game:edit', params: params });
                    return;
                }
                if (!game) {
                    game = _.find(this.allGamesByCourseType, { slug });
                }
                if (game) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_bonusCreateError', {
                            bonusGameName: this.$i18n.t(game.label),
                        })
                    );
                }
            },
            async submitForm() {
                if (this.isLoading) {
                    return;
                }
                if (!(this.form.games && !_.isEmpty(this.form.games))) {
                    this.$toasted.error(this.$i18n.t('homework.homework_create_noGamesError'));
                    return;
                }
                if (this.puzzlesAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_puzzle'),
                        })
                    );
                    return;
                }
                if (this.puzzleDatesMissMatch) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_puzzleGameDatesMissMatch', {
                            gameName: this.$i18n.t('common.common_gameName_puzzle'),
                        })
                    );
                    return;
                }
                if (this.wordsFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_wordsField'),
                        })
                    );
                    return;
                }
                if (this.correctiveSamplesIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_correctiveSamples'),
                        })
                    );
                    return;
                }
                if (this.shutterIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_shutter'),
                        })
                    );
                    return;
                }
                if (this.anagramsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_anagrams'),
                        })
                    );
                    return;
                }
                if (this.textsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_texts'),
                        })
                    );
                    return;
                }
                if (this.textsDatesMissMatch) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_textsGameDatesMissMatch', {
                            gameName: this.$i18n.t('common.common_gameName_texts'),
                        })
                    );
                    return;
                }
                if (this.lettersFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_lettersField'),
                        })
                    );
                    return;
                }
                if (this.catchWordIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_catchWord'),
                        })
                    );
                    return;
                }
                if (this.catchWordOnlineIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_catchWordOnline'),
                        })
                    );
                    return;
                }
                if (this.textsOnlineAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_textsOnline'),
                        })
                    );
                    return;
                }
                if (this.punctuationMarksAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_punctuationMarks'),
                        })
                    );
                    return;
                }
                if (this.shutterOnlineIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_shutterOnline'),
                        })
                    );
                    return;
                }
                if (this.anagramsOnlineAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_anagramsOnline'),
                        })
                    );
                    return;
                }
                if (this.classificationsIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_classifications'),
                        })
                    );
                    return;
                }
                if (this.fourthOneIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_fourthOne'),
                        })
                    );
                    return;
                }
                if (this.searchIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_search'),
                        })
                    );
                    return;
                }
                if (this.digitCouplesAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_digitCouples'),
                        })
                    );
                    return;
                }
                if (this.diadaIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_diada'),
                        })
                    );
                    return;
                }
                if (this.memoryIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_memory'),
                        })
                    );
                    return;
                }
                if (this.memoIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_memo'),
                        })
                    );
                    return;
                }
                if (this.vocabularyMemoIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_vocabularyMemo'),
                        })
                    );
                    return;
                }
                if (this.associationsIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_associations'),
                        })
                    );
                    return;
                }
                if (this.vocabularyWordsIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_vocabularyWords'),
                        })
                    );
                    return;
                }
                if (this.tabularMultiplicationIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_tabularMultiplication'),
                        })
                    );
                    return;
                }
                const firstBonusWithoutAccess = await this.getFirstFormBonusGameWithoutAccess();
                if (firstBonusWithoutAccess) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_bonusCreateError', {
                            bonusGameName: this.$i18n.t(firstBonusWithoutAccess.label),
                        })
                    );
                    return;
                }
                this.form.dates = this.dates.map(date => moment(date).format('YYYY-MM-DD'));
                if (this.validateDates(this.form.dates)) {
                    this.$toasted.error(this.$i18n.t('homework.homework_create_doubleDatesError'));
                    return;
                }
                this.form.games.forEach(game => {
                    game.courseId && delete game.id;
                });
                this.$validator
                    .validateAll({
                        school: this.form.school,
                        grades: this.form.grades,
                        students: this.form.students,
                        date: this.form.dates[0],
                    })
                    .then(validate => {
                        if (this.id && validate) {
                            this.isLoading = true;
                            this.form.homeworkTemplate
                                ? Object.assign(this.form, { template_name: this.form.homeworkTemplate.name })
                                : undefined;
                            delete this.form.homeworkTemplate;
                            HomeWorkApi.update(this.id, this.form)
                                .then(() => {
                                    this.isLoading = false;
                                    this.isSuccessfullyUpdated = true;
                                    this.$router.back();
                                })
                                .catch(error => {
                                    this.isLoading = false;
                                    if (error.status === 403) {
                                        this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                                    } else {
                                        this.$toasted.error(this.$i18n.t('homework.homework_create_homeworkEditError'));
                                    }
                                });
                        } else if (validate) {
                            this.isLoading = true;
                            this.form.homeworkTemplate
                                ? Object.assign(this.form, { template_name: this.form.homeworkTemplate.name })
                                : undefined;
                            delete this.form.homeworkTemplate;
                            HomeWorkApi.create(this.form)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$router.push({
                                        name: 'homework:list',
                                        params: { isSuccessfullyCreated: true },
                                    });
                                })
                                .catch(error => {
                                    this.isLoading = false;
                                    if (error && error.status === 402) {
                                        const failedStudents = error.headers && error.headers['x-failed-students'];
                                        if (failedStudents) {
                                            console.error('Homework limit exceeded for students: ' + failedStudents);
                                        }
                                        return;
                                    }
                                    this.$toasted.error(this.$i18n.t('homework.homework_create_homeworkCreateError'));
                                });
                        }
                    })
                    .catch(() => {
                        this.$toasted.error(this.$i18n.t('errors.fill_form'));
                    });
            },
            async getFirstFormBonusGameWithoutAccess() {
                const selectedGamesSlugSet = new Set(this.form.games.map(({ slug }) => slug));
                const selectedBonusGames = this.bonusGames.filter(({ slug }) => selectedGamesSlugSet.has(slug));
                return selectedBonusGames.find(({ slug }) => !this.availableBonusGamesSlugSet.has(slug));
            },
            validateDates(dates) {
                return _.uniq(dates).length !== dates.length;
            },
            addAllStudentsToGrade() {
                this.form.students = _.unionBy(this.form.students, this.students, 'id');
            },
            getPreview(game) {
                switch (game) {
                    case 'MultiplicationAndDivision':
                        return 'mult-div-preview';
                    case 'FlashCards':
                    case 'InteractiveFlashCards':
                        return 'flash-cards-preview';
                    case 'AdditionAndSubtraction':
                    case 'AdditionAndSubtractionWithTime':
                        return 'add-sub-preview';
                    case 'Equation':
                        return 'equation-preview';
                    case 'Factorization':
                        return 'factorization-preview';
                    case 'DivideItRight':
                        return 'divide-it-right-preview';
                    case 'ChooseItRight':
                        return 'choose-it-right-preview';
                    case 'DivideUnstressedVowels':
                        return 'divide-unstressed-vowels-preview';
                    case 'WordStructure':
                        return 'word-structure-preview';
                    case 'ShutterRussianLanguage':
                        return 'shutter-russian-language-preview'
                    case 'SentenceParsing':
                        return 'sentence-parsing-preview';
                    case 'VocabularyWordsRus':
                        return 'vocabulary-words-rus-preview';
                    case 'LettersSoundsSyllables':
                        return 'letters-sounds-syllables-preview';
                    case 'TransferSyllables':
                        return 'transfer-syllables-preview';
                    case 'TransferSyllablesSchoolPreparing':
                        return 'transfer-syllables-school-preparing-preview';
                    case 'HardSoftConsonants':
                        return 'hard-soft-consonants-preview';
                    case 'HardSoftConsonantsSchoolPreparing':
                        return 'hard-soft-consonants-school-preparing-preview';
                    case 'VocabularyMemoRus':
                        return 'vocabulary-memo-rus-preview';
                    case 'WordDrum':
                        return 'word-drum-preview';
                    case 'TranscriptionInWord':
                        return 'transcription-in-word-preview';
                    case 'VoicedAndDeafConsonants':
                        return 'voiced-and-deaf-consonants-preview';
                    case 'PartsOfSpeech':
                        return 'parts-of-speech-preview';
                    case 'ParsingSentencePartsSpeech':
                        return 'parsing-sentence-parts-speech';
                    case 'SortOneMany':
                        return 'sort-one-many-preview';
                    case 'GenericWords':
                        return 'generic-words-preview';
                    case 'VerbTenses':
                        return 'verb-tenses-preview';
                    case 'PunctuationMarksPreview':
                        return 'punctuation-marks-preview';
                    case 'Alphabet':
                        return 'alphabet-preview';
                    case 'Anzan':
                        return 'anzan-preview';
                    case 'ConnectThePuzzles':
                        return 'connect-the-puzzles-preview';
                    case 'Orthograph':
                        return 'orthograph-preview'
                    case 'AntonymsRussianLanguage':
                        return 'antonyms-russian-language'
                    case 'SynonymsRussianLanguage':
                        return 'synonyms-russian-language-preview';
                }
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({
                    all: true,
                    withActiveAccount: true,
                })
                    .then(data => {
                        let schools = data.schools;
                        this.schools = schools ? schools : [];
                        this.loadingSchools = false;
                    })
                    .catch(() => {
                        this.loadingSchools = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            getGrades() {
                this.loadingGrades = true;
                GradeApi.list({
                    schoolId: this.form.school.id,
                    all: true,
                    status: 'active',
                    withActiveStudents: true,
                })
                    .then(data => {
                        let grades = data.grades;
                        this.grades = grades ? grades : [];
                        this.loadingGrades = false;
                    })
                    .catch(() => {
                        this.loadingGrades = false;
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            getStudents(grade) {
                return UserApi.list({
                    type: 'student',
                    status: 'active',
                    gradesIds: grade ? [grade.id] : this.form.grades.map(grade => grade.id),
                    all: true,
                })
                    .then(data => {
                        let students = data.users;
                        return students ? students : [];
                    })
                    .catch(() => {
                        this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                    });
            },
            getMotivationTypeByCourse(course) {
                switch (course) {
                    case 'fastReading':
                        return 'detective';
                    case 'mentalArithmetic':
                        return 'map';
                    case 'onlineSchool':
                        return 'none';
                    case 'mathMagic':
                        return 'none';
                    case 'memoryDevelopment':
                        return 'none';
                    case 'multiplication':
                        return 'none';
                    case 'readingEn':
                        return 'none';
                    case 'russianLanguage':
                        return 'none';
                }
            },
            async isBonusGameHasAccess(game) {
                const params = {
                    courseType: kebabCase(this.courseType),
                    gameName: game.slug,
                    schoolsIds: [this.form.school.id],
                };
                const isAccess = await BonusGamesApi.checkAccessForBonusGameForHomework(params);
                return Boolean(isAccess);
            },
            async updateAvailableBonusGamesSlugSet() {
                this.availableBonusGamesSlugSet = new Set();
                if (this.courseType) {
                    this.availableBonusGamesSlugSet = await this.computeAvailableBonusGamesSlugSet();
                }
            },
            async computeAvailableBonusGamesSlugSet() {
                const set = new Set();
                const arrayAccessBonuses = await Promise.all(
                    this.bonusGames.map(game => this.isBonusGameHasAccess(game))
                );
                arrayAccessBonuses.forEach((isAccess, index) => {
                    isAccess && set.add(this.bonusGames[index].slug);
                });
                return set;
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            homeworkLimitTariff() {
              return TARIFF_IDS_WITH_HOMEWORK_LIMIT.includes(this.user.schools[0].tariffId);
            },
            shutterIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Shutter') {
                        switch (game.parameters.default.mode) {
                            case 'wordColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'syllableColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'text':
                                return !(
                                    game.parameters.default.sourceText && game.parameters.default.sourceText.length
                                );
                        }
                    }
                    return false;
                });
            },
            shutterOnlineIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'ShutterOnline') {
                        switch (game.parameters.default.mode) {
                            case 'wordColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'syllableColumn':
                                return !(
                                    game.parameters.default.selectedGroups &&
                                    game.parameters.default.selectedGroups.length
                                );
                            case 'text':
                                return !(
                                    game.parameters.default.sourceText && game.parameters.default.sourceText.length
                                );
                        }
                    }
                    return false;
                });
            },
            puzzlesAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Puzzle') {
                        if (_.isArray(game.parameters.default)) {
                            return !game.parameters.default.some(params => params.games.length && params.image);
                        }
                        return !(game.parameters.default.games.length && game.parameters.default.image);
                    }
                    return false;
                });
            },
            textsOnlineAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'TextsOnline') {
                        if (_.isArray(game.parameters.default)) {
                            return game.parameters.default.find(item => !item.sourceText);
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            punctuationMarksAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'PunctuationMarks') {
                        if (_.isArray(game.parameters.default)) {
                            return game.parameters.default.find(item => !item.sourceText);
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            anagramsOnlineAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'AnagramsOnline') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            textsDatesMissMatch() {
                return this.form.games.some(game => {
                    if (game.slug === 'Texts') {
                        const amountOfTextGames = Array.isArray(game.parameters.default)
                            ? game.parameters.default.length
                            : 1;
                        return amountOfTextGames !== this.dates.length;
                    }
                    return false;
                });
            },
            puzzleDatesMissMatch() {
                return this.form.games.some(game => {
                    if (game.slug === 'Puzzle') {
                        const amountOfTextGames = Array.isArray(game.parameters.default)
                            ? game.parameters.default.length
                            : 1;
                        return amountOfTextGames !== this.dates.length;
                    }
                    return false;
                });
            },
            textsAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Texts') {
                        if (Array.isArray(game.parameters.default)) {
                            return game.parameters.default.some(innerGame => {
                                return !innerGame.sourceText;
                            });
                        }
                        return !game.parameters.default.sourceText;
                    }
                    return false;
                });
            },
            anagramsAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Anagrams') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            wordsFieldIsIncomplete() {
                return this.form.games.some(game => {
                    if (
                        game.slug === 'WordsField' ||
                        game.slug === 'WordsFieldOnline' ||
                        game.slug === 'WordsFieldReadingEn'
                    ) {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            correctiveSamplesIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CorrectiveSamples' || game.slug === 'CorrectiveSamplesWithTime') {
                        return !(game.parameters.default.selectedTheme && game.parameters.default.selectedTheme.theme);
                    }
                    return false;
                });
            },
            tabularMultiplicationIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'TabularMultiplication') {
                        return !game.parameters.default.numbers.length;
                    }
                    return false;
                });
            },
            lettersFieldIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'LettersField' || game.slug === 'LettersFieldOnline') {
                        return !(
                            game.parameters.default.selectedLetters && game.parameters.default.selectedLetters.length
                        );
                    }
                    return false;
                });
            },
            catchWordIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CatchWord' || game.slug === 'CatchWordReadingEn') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            catchWordOnlineIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'CatchWordOnline') {
                        return !(
                            game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                        );
                    }
                    return false;
                });
            },
            classificationsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Classifications') {
                        return !(
                            game.parameters.default.selectedTopics && game.parameters.default.selectedTopics.length
                        );
                    }
                    return false;
                });
            },
            associationsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Associations') {
                        return !(
                            game.parameters.default.selectedSubTopics &&
                            game.parameters.default.selectedSubTopics.length
                        );
                    }
                    return false;
                });
            },
            vocabularyWordsIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'VocabularyWords') {
                        return !game.parameters.default.themes.length;
                    }
                    return false;
                });
            },
            fourthOneIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'FourthOne') {
                        return !(
                            game.parameters.default.themes &&
                            game.parameters.default.themes.length &&
                            game.parameters.default.themes.every(theme => theme.first && theme.second)
                        );
                    }
                    return false;
                });
            },
            searchIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Search') {
                        return !(
                            game.parameters.default.searchTopic &&
                            game.parameters.default.selectedTopics &&
                            game.parameters.default.selectedTopics.length
                        );
                    }
                    return false;
                });
            },
            digitCouplesAreIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'DigitCouples') {
                        return !(game.parameters.default.difficulties && game.parameters.default.difficulties.length);
                    }
                    return false;
                });
            },
            diadaIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Diada') {
                        return !game.parameters.default.leftColumnExample;
                    }
                    return false;
                });
            },
            memoryIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'Memory') {
                        return !(game.parameters.default.selectedItems && game.parameters.default.selectedItems.length);
                    }
                    return false;
                });
            },
            memoIsIncomplete() {
                return this.form.games.some(game => {
                    if (['Memo', 'MemoBonusGames'].includes(game.slug)) {
                        return !game.parameters.default.selectedItems?.length;
                    }
                    return false;
                });
            },
            vocabularyMemoIsIncomplete() {
                return this.form.games.some(game => {
                    if (game.slug === 'VocabularyMemo') {
                        return !game.parameters.default.selectedItems?.value;
                    }
                    return false;
                });
            },
            templatesPlaceholder() {
                if (this.isMainParametersSet) {
                    if (!this.homeworkTemplates.length) {
                        return this.$i18n.t('homework.homework_create_templateNotFound');
                    }
                    return this.form.templateName || '';
                }
                return this.$i18n.t('homework.homework_create_chooseGrades&Students');
            },
            studentsPlaceholder() {
                if (this.form.grades.length && !this.students.length) {
                    return this.$i18n.t('homework.homework_create_noStudentsInGrade');
                }
                if (!this.form.grades.length) {
                    return this.$i18n.t('fields.fields_selectGradeFirst');
                }
                return '';
            },
            gradesPlaceholder() {
                if (this.form.school) {
                    if (!this.grades.length) {
                        return this.$i18n.t('homework.homework_create_noGradesInSchool');
                    }
                    return this.$i18n.t('homework.homework_create_chooseGrades');
                }
                return this.$i18n.t('fields.fields_selectSchoolFirst');
            },
            availableGrades() {
                if (this.form.grades.length) {
                    return this.grades.filter(grade => grade.course.id === this.form.grades[0].course.id);
                }
                return this.grades;
            },
            courseType() {
                return this.form.grades?.[0]?.access || null;
            },
            games() {
                if (!_.isEmpty(this.form.grades)) {
                    this.form.grades.forEach(grade => {
                        grade.course.games.forEach(game => {
                            this.gamesForComparison.push(game);
                        });
                    });
                    let games = _.cloneDeep(this.getGamesAfterComparison()).filter(
                        ({ slug }) => slug !== 'Presentations'
                    );
                    games.forEach(game => (game.name = this.getGameName(game)));
                    if (this.user.schools[0].isBonusGamesActive) {
                        games.push(...this.bonusGames);
                    }
                    return games;
                } else {
                    return [];
                }
            },
            bonusGames() {
                return this.allGamesByCourseType.filter(({ isBonusGame }) => isBonusGame);
            },
            allGamesByCourseType() {
                if (!this.courseType) return [];
                const courseTypeKebab = kebabCase(this.courseType);
                const games = TrainerGames.games.filter(({ courseType }) => courseType === courseTypeKebab);
                games.forEach(game => (game.name = this.getGameName(game)));
                return games;
            },
            availableBonusGamesWithOldBonusGames() {
                return this.bonusGames.filter(
                    ({ slug }) => this.oldBonusGamesSlugSet.has(slug) || this.availableBonusGamesSlugSet.has(slug)
                );
            },
            isMainParametersSet() {
                if (this.form.students) {
                    return (
                        this.form.school !== null &&
                        this.form.grade !== null &&
                        this.form.students.length > 0 &&
                        this.dates.length > 0
                    );
                }
                return false;
            },
            homeworkEditorHeader() {
                return this.$route.name === 'homework:create'
                    ? this.$i18n.t('homework.homework_create_createHomework')
                    : this.$i18n.t('homework.homework_create_editHomework');
            },
            ...mapState({
                homework: state => state.trainer.homework,
                user: state => state.auth.user,
            }),
        },
        components: {
            AddSubPreview,
            FlashCardsPreview,
            MultDivPreview,
            EquationPreview,
            FactorizationPreview,
            TransferSyllablesPreview,
            TransferSyllablesSchoolPreparingPreview,
            HardSoftConsonantsPreview,
            HardSoftConsonantsSchoolPreparingPreview,
            VocabularyMemoRusPreview,
            WordDrumPreview,
            OrthographPreview,
            AntonymsRussianLanguagePreview,
            TranscriptionInWordPreview,
            VoicedAndDeafConsonantsPreview,
            PartsOfSpeechPreview,
            ParsingSentencePartsSpeechPreview,
            GenericWordsPreview,
            VerbTensesPreview,
            SortOneManyPreview,
            AlphabetPreview,
            DivideItRightPreview,
            ChooseItRightPreview,
            DivideUnstressedVowelsPreview,
            WordStructurePreview,
            ShutterRussianLanguagePreview,
            SentenceParsingPreview,
            VocabularyWordsRusPreview,
            LettersSoundsSyllablesPreview,
            SynonymsRussianLanguagePreview,
            PunctuationMarksPreview,
            AnzanPreview,
            ConnectThePuzzlesPreview,
            GamesList,
        },
        beforeRouteLeave(to, from, next) {
            if (to.name !== 'game:edit') {
                this.$store.dispatch('setHomework', null);
                this.$store.dispatch('setPuzzleGame', null);
                this.$store.dispatch('setGamesParameters', null);
                if (this.isSuccessfullyUpdated) {
                    to.params.isSuccessfullyUpdated = true;
                }
            }
            next();
        },
        mixins: [TrainerUtilities, ComparingTrainersParameters, getBase64FromUrl],
    };
</script>

<style lang="scss" scoped>
    .row {
        margin: 0;
    }
    .list {
        margin: 0;
        padding: 0;
        height: 100%;
        background-color: $x-color-white;
        box-sizing: border-box;
        font-weight: normal;
        border-radius: 0;
        @include media($sm) {
            padding: 30px;
            border-radius: $border-radius-20;
        }
    }
    .list__content {
        margin: 0;
        padding: 15px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: $border-radius-20;
    }
    .form-container__header {
        margin-bottom: 25px;
        text-align: center;
    }
    .form-container__fields {
        max-width: 640px;
        margin: 0 auto 30px auto;
        @include media($sm) {
            margin: 0 auto 40px auto;
        }
    }
    .form-container__label {
        margin: 0 0 20px 0;
        width: 100%;
        max-width: 380px;
        text-align: left;
        @include media($sm) {
            margin: 0 20px 0 0;
            width: 20%;
            text-align: right;
        }
    }
    .form-container__label_nowrap {
        @include media($xlg) {
            white-space: nowrap;
        }
    }
    .form-container__label_hidden {
        display: none;
        @include media($sm) {
            display: block;
        }
    }
    .form-container__title {
        font-size: 24px;
        line-height: 30px;
        font-weight: 500;
    }
    .form-container__column {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 30px;
        @include media($sm) {
            flex-direction: row;
            margin-bottom: 20px;
        }
    }
    .form-container__select {
        width: 100%;
        max-width: 380px;
        .datepicker-input-container {
            margin-bottom: 0;
            width: 230px;
            @include media($sm) {
                width: auto;
            }
        }
        .all-students-text {
            margin-top: 10px;
            a {
                text-decoration: underline;
                color: $hsl-color-blue-56;
                &:hover {
                    text-decoration: none;
                }
            }
        }
    }
    .form-container__divider {
        width: 70% !important;
        @media screen and (max-width: 1399px) {
            width: 85% !important;
        }
        @media screen and (max-width: 919px) {
            width: 100% !important;
        }
    }
    .base-settings-text {
        text-align: center;
        margin: 10px 0 30px 0;
        @include media($sm) {
            margin: 30px 0 20px 0;
        }
    }
    .form-container-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        max-width: 640px;
        margin: 0 auto;
        @media screen and (max-width: 575px) {
            display: block;
        }
    }
    .form-container-footer__button {
        margin: 0 auto 6px auto;
        width: 176px;
        @include media($sm) {
            margin: 0;
            width: auto;
        }
    }
    .form-container-footer__button-submit {
        display: flex;
        min-width: 134px;
        margin-left: 0;
        margin-top: 20px;
        @include media($sm) {
            margin: 0 0 0 20px;
        }
    }
    .form-container-footer__right {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        @include media($sm) {
            flex-direction: row;
        }
    }
    .info-text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: #828282;
    }
    .delete-icon {
        margin-left: 10px;
        color: $hsl-color-green-48;
        &:hover {
            color: $hsl-color-red-62;
        }
        @media screen and (max-width: 575px) {
            position: absolute;
            top: 50%;
            right: 30%;
        }
        @media screen and (max-width: 470px) {
            right: 20%;
        }
        @media screen and (max-width: 410px) {
            right: 0;
        }
        @media screen and (max-width: 339px) {
            right: -3%;
        }
    }
    .games-fields {
        margin: 25px auto;
    }
</style>
